import React from 'react';
import { FormattedMessage } from 'react-intl';

import { trackAction } from 'app/shared/utils/tracking';
import { getNetworkTrackingPropertyGroup } from 'app/dealer/utils';

export const onLogoutClick = ({ logout, network }) => {
  const trackingNetwork = getNetworkTrackingPropertyGroup(network);

  trackAction('logout_click', { category: 'dealer_portal' }, trackingNetwork);
  logout();
};

export const DealerNavigation = props => [
  {
    border: true,
    paths: ['/dealer/dashboard'],
    title: (
      <FormattedMessage
        id="shared.components.NavigationPane.NavigationItem.myDashboard"
        defaultMessage="Übersicht"
      />
    ),
    to: '/dealer/dashboard',
  },
  {
    border: true,
    paths: ['/dealer/leads'],
    subNav: [
      {
        paths: ['/dealer/leads/open-leads'],
        title: (
          <FormattedMessage
            id="shared.components.NavigationPane.NavigationItem.openLeads"
            defaultMessage="Offene Leads"
          />
        ),
        to: '/dealer/leads/open-leads',
      },
      {
        paths: ['/dealer/leads/closed-leads'],
        title: (
          <FormattedMessage
            id="shared.components.NavigationPane.NavigationItem.closedLeads"
            defaultMessage="Abgeschlossene Leads"
          />
        ),
        to: '/dealer/leads/closed-leads',
      },
    ],
    title: (
      <FormattedMessage
        id="shared.components.NavigationPane.NavigationItem.myLeads"
        defaultMessage="Meine Leads"
      />
    ),
    to: '/dealer/leads',
  },
  {
    border: true,
    paths: ['/dealer/listings'],
    title: (
      <FormattedMessage
        id="shared.components.NavigationPane.NavigationItem.myListings"
        defaultMessage="Meine Inserate"
      />
    ),
    to: '/dealer/listings',
  },
  {
    border: true,
    paths: ['/dealer/service'],
    title: (
      <FormattedMessage
        id="shared.components.NavigationPane.NavigationItem.service"
        defaultMessage="Service"
      />
    ),
    subNav: [
      {
        paths: ['/dealer/service/contact'],
        title: (
          <FormattedMessage
            id="shared.components.NavigationPane.NavigationItem.contact"
            defaultMessage="Kontakt"
          />
        ),
        to: '/dealer/service/contact',
      },
      {
        paths: ['/dealer/service/faq'],
        title: (
          <FormattedMessage
            id="shared.components.NavigationPane.NavigationItem.faqs"
            defaultMessage="FAQs"
          />
        ),
        to: '/dealer/service/faq',
      },
    ],
    to: '/dealer/service',
  },
  {
    border: true,
    paths: ['/dealer/account'],
    title: (
      <FormattedMessage
        id="shared.components.NavigationPane.NavigationItem.account"
        defaultMessage="Mein Autohaus"
      />
    ),
    subNav: [
      {
        paths: ['/dealer/account/network'],
        title: (
          <FormattedMessage
            id="shared.components.NavigationPane.myNetwork"
            defaultMessage="Meine Stammdaten"
          />
        ),
        to: '/dealer/account/network',
      },
      {
        paths: ['/dealer/account/branches', '/dealer/account/new-branch'],
        title: (
          <FormattedMessage
            id="shared.components.NavigationPane.myBranches"
            defaultMessage="Meine Filialen"
          />
        ),
        to: '/dealer/account/branches',
      },
      {
        paths: ['/dealer/account/billing'],
        title: (
          <FormattedMessage
            id="shared.components.NavigationPane.billing"
            defaultMessage="Meine Rechnungen"
          />
        ),
        to: '/dealer/account/billing',
      },
      {
        paths: ['/dealer/account/settings'],
        title: (
          <FormattedMessage
            id="shared.components.NavigationPane.settings"
            defaultMessage="Meine Einstellungen"
          />
        ),
        to: '/dealer/account/settings',
      },
      {
        paths: ['/dealer/account/dealer-profile-settings'],
        title: (
          <FormattedMessage
            id="shared.components.NavigationPane.dealerProfileSettings"
            defaultMessage="Meine Händler-Profilseiten"
          />
        ),
        to: '/dealer/account/dealer-profile-settings',
      },
      {
        paths: ['/dealer/account/terms'],
        title: (
          <FormattedMessage
            id="shared.components.NavigationPane.terms"
            defaultMessage="Händler-AGB (Kooperationsvertrag)"
          />
        ),
        to: '/dealer/account/terms',
      },
    ],
    to: '/dealer/account',
  },
  {
    icon: 'logout',
    title: (
      <FormattedMessage
        id="shared.components.NavigationPane.NavigationItem.logout"
        defaultMessage="Logout"
      />
    ),
    onClick: () => onLogoutClick(props),
  },
];
